export default __webpack_public_path__ + "static/media/membership-3.09fc40e9.png";